import { convertsCentsToCurrency } from '@npi/buddy-utils';

import formatCentsToLocaleCurrency from 'src/utils/finance';

export function getValueBetweenRangeError(lowestValueInCents: number, highestValueInCents: number) {
    const lowestValueInCurrency = formatCentsToLocaleCurrency(
        lowestValueInCents,
        navigator.language
    );
    const highestValueInCurrency = formatCentsToLocaleCurrency(
        highestValueInCents,
        navigator.language
    );
    const isLowestFinite = Number.isFinite(lowestValueInCents);
    const isHighestFinite = Number.isFinite(highestValueInCents);

    if (isLowestFinite && isHighestFinite) {
        return `Value must be between ${lowestValueInCurrency} and ${highestValueInCurrency}`;
    } else if (isLowestFinite) {
        return `Value must be greater than ${lowestValueInCurrency}`;
    } else if (isHighestFinite) {
        return `Value must be less than ${highestValueInCurrency}`;
    }
}

export function parseCurrencyInput(input: string): string {
    const trimmed = input.trim().toLowerCase();
    if (trimmed.endsWith('k')) {
        const num = Number.parseFloat(trimmed.slice(0, -1));
        if (!Number.isNaN(num)) {
            return (num * 1000).toString();
        }
    }
    return input;
}

export function getInitialCurrencyValue({
    defaultValueInCents,
    defaultValueInCurrency,
}: {
    defaultValueInCents?: number;
    defaultValueInCurrency?: number;
}) {
    if (defaultValueInCents !== undefined && defaultValueInCents !== null) {
        // Return as number string without forcing two decimal places
        const value = convertsCentsToCurrency(defaultValueInCents);
        return value.toString();
    }

    if (defaultValueInCurrency !== undefined && defaultValueInCurrency !== null) {
        // Return as number string without forcing two decimal places
        return defaultValueInCurrency.toString();
    }
    return '0';
}

export function getDefaultValue({
    defaultValueInCents,
    defaultValue,
}: {
    defaultValueInCents?: number;
    defaultValue?: number | string;
}) {
    if (defaultValueInCents !== undefined && defaultValueInCents !== null) {
        return convertsCentsToCurrency(defaultValueInCents).toFixed(2);
    }
    if (defaultValue !== undefined && defaultValue !== null) {
        return typeof defaultValue === 'string'
            ? Number.parseFloat(defaultValue).toFixed(2)
            : defaultValue.toFixed(2);
    }
    return '0.00';
}

export function handleIsValueWithinRangeOfMinAndMax(value: number, min?: number, max?: number) {
    const highestValue = max;
    const lowestValue = min;

    if (
        (Number.isFinite(lowestValue) && value < lowestValue) ||
        (Number.isFinite(highestValue) && value > highestValue)
    ) {
        return false;
    }
    return true;
}

export default {
    getValueBetweenRangeError,
    parseCurrencyInput,
    getInitialCurrencyValue,
    getDefaultValue,
    handleIsValueWithinRangeOfMinAndMax,
};
